<!-- 二期面板组件 -->

<template>
  <div 
    class="panel-v2 content-area"
    :class="typeClass"
    :style="{width: width}"
  >
    <div v-if="showGoBack" class="top-button" @click="goBack">
      <i class="el-icon-arrow-left"></i>
    </div>
    <div v-if="title" class="title-line">
      <div class="title">{{ title }}</div>
      <div class="solt-area">
        <slot name="title-solt"></slot>
      </div>
    </div>
    <div class="content">
      <slot name="content-solt"></slot>
    </div>
    <div v-if="mode !== 'simple'" class="button-line">
      <el-button @click="toPrevPage">Back</el-button>
      <el-button @click="toNextPage" v-if="mode === 'add'" class="pc-btn" type="primary">Next</el-button>
      <el-button @click="toNextPage" v-if="mode === 'edit'" class="pc-btn" type="primary">Save</el-button>
      <el-button @click="toNextPage" v-if="mode === 'submit'" class="pc-btn" type="primary">Submit</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PanelV2',
    props: {
      type: {
        type: String,
        // 'w1' 380px
        // 'w2' 540px
        // 'w3' 688px
        // 'w4' 750px
        // 'w5' 806px
        // 'w6' 814px
        // 'w7' 908px
        // 'w8' 1096px
        default: "w1",
      },
      mode: {
        type: String,
        // add 新增
        // edit 编辑
        // simple 无底部按钮
        default: 'add',
      },
      width: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      showGoBack: {
        type: Boolean,
        default: false,
      },
      goBack: {
        type: Function,
        default:  function () {
          window.history.go(-1);
        },
      },
      customPrevClick: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      typeClass() {

        return {
          [this.type]: true,
        }
      }
    },
    methods: {
      toPrevPage() {
        if (this.customPrevClick) {
          this.$emit('prevClick')
        } else {
          this.$router.go(-1)
        }
      },
      toNextPage() {
        this.$emit('nextClick')
      }
    },
  }
</script>

<style lang="scss">
  .panel-v2.content-area {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 16px #00000014;
    border: 0px;
    border-radius: 8px;
    padding: 32px 24px;

    &.w1 {
      width: 380px;
    }

    &.w2 {
      width: 540px;
    }

    &.w3 {
      width: 688px;
    }

    &.w4 {
      width: 750px;
    }

    &.w5 {
      width: 806px;
    }

    &.w6 {
      width: 814px;
    }

    &.w7 {
      width: 908px;
    }

    &.w8 {
      width: 1096px;
    }

    &.w9 {
      width: 406px;
      .top-button {
            top: 8px;
            left: 0px;
          }
      .el-form {
        margin: 32px 0 0 !important;

        .el-form-item {
          width: 100% !important;
        }

        label {
          font: normal normal normal 16px/24px Nunito;
          letter-spacing: 0px;
          color: #2E2E2E;
        }
      }

    }

    .top-button {
      cursor: pointer;
      position: relative;
      top: -15px;
      left: -10px;
      i { 
        color: #0072D8;
        font-size: 24px;
      }
    }

    .title-line {
      border-bottom: 1px solid #E4E4E4;
      padding-bottom: 16px;
      display: flex;
      justify-content: space-between;

      .title {
        text-align: left;
        font: normal normal normal 20px/24px Nunito-bold;
        letter-spacing: 0px;
        color: #2E2E2E;
      }

      .btn-action {
        text-align: right;
        text-decoration: underline;
        font: normal normal normal 16px/24px Nunito-bold;
        letter-spacing: 0px;
        color: #0072D8;
        text-transform: uppercase;
      }
    }

    .content {
      padding: 32px 0 0 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      
       > div {
         width: 100%;
       }

      .el-form {
        width: 100%;
        margin: 0;

        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .el-form-item {
          width: 48%;
          margin-bottom: 16px ;
          // width: 100%;
        }

        .el-form-item.left-box {
          width: 23.2%;
        }
        .el-form-item.right-box {
          width: 20.7%;
        }
        .el-form-item.minileft-box {
          width: 20px !important;
        }
        .el-form-item.minimiddle-box {
          width: 90px;
        }
        .el-form-item.miniright-box {
          width: 90px;
        }
        

        .divider {
          border: none;
          border-bottom: 1px solid #E4E4E4;
          width: 100%;
        }
      }

    }

    .button-line {
      // border: 1px solid pink;
      margin-top: 34px;
      text-align: right;
      // justify-content: end;
      // display: flex;
    }

  }
</style>
